import React from 'react';
import { Dispatch } from '@reduxjs/toolkit';

import { Payslip } from '../../../../interfaces/employee/payslip.interface';

import { PayslipActions } from '../../../../actions/payslip/payslip.actions';
import { RemovePayslipAction } from '../../../../actions/payslip/payslip.types';

import { useAppDispatch, useRemoval } from '../../../../hooks';

import { Modal } from '../../../../components/modal/Modal';
import { ModalLayout } from '../../../../components/modal/ModalLayout';
import RemoveModal from '../../../../components/modal/remove/RemoveModal';

interface Props {
  onRemoval?: () => void;
}

const RemovePayslipContainer = ({ onRemoval }: Props) => {
  const dispatch: Dispatch<RemovePayslipAction> = useAppDispatch();

  const { element, showModal, setShowModal } = useRemoval();

  const onClose = () => setShowModal(false);

  const handleConfirm = (onComplete: () => void) => {
    dispatch(
      PayslipActions.removePayslip((element as Payslip).id as number, () => {
        onComplete();
        onClose();
        if (onRemoval) {
          onRemoval();
        }
      })
    );
  };

  return (
    <>
      {showModal && (
        <Modal>
          <ModalLayout onClose={onClose} title="Remove Payslip">
            <RemoveModal title="this payslip" onConfirm={handleConfirm} />
          </ModalLayout>
        </Modal>
      )}
    </>
  );
};

export default RemovePayslipContainer;
